export default __webpack_public_path__ + "static/media/button__menu.bcd8fc97.svg";